import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { DocumentType } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "@Front/Api/types";
import type { IGetDocumentTypesparams, IPutDocumentTypesParams, IPostDocumentTypesParams } from "../DocumentTypes";
import {
	buildDocumentTypesCreatePayload,
	buildDocumentTypesUpdatePayload,
} from "@Front/Api/LeCoffreApi/helpers/businessRequestPayloadHelpers";

export function createGetMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (q: IGetDocumentTypesparams): Promise<DocumentType[]> => {
		const url = new URL(baseUrl);
		const query = { q };
		if (q) baseNotary.appendJsonSearchParams(url, query);
		try {
			return await baseNotary.getRequest<DocumentType[]>(url);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPostMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (body: IPostDocumentTypesParams): Promise<DocumentType> => {
		const url = new URL(baseUrl);
		try {
			const payload = buildDocumentTypesCreatePayload(body);
			return await baseNotary.postRequest<DocumentType>(url, payload);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createGetByUidMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (uid: string, q?: QueryPayload): Promise<DocumentType> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		const query = { q };
		if (q) baseNotary.appendJsonSearchParams(url, query);
		try {
			return await baseNotary.getRequest<DocumentType>(url);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPutMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (uid: string, body: IPutDocumentTypesParams): Promise<DocumentType> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			const payload = buildDocumentTypesUpdatePayload(body);
			return await baseNotary.putRequest<DocumentType>(url, payload);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}
